import { differenceInDays } from 'date-fns'

import { pluralize } from '@/lib/helpers'

import type { GetDurationText } from './types'

export const getDurationText: GetDurationText = (start, end) => {
  if (!start || !end) {
    return null
  }
  const nights = differenceInDays(new Date(end), new Date(start))

  return `${nights + 1} ${pluralize(nights + 1, 'day')}, ${nights} ${pluralize(
    nights,
    'night'
  )}`
}
